if ($('.id--8').length) {
    $('#register-form').before($('footer#footer .bannerLoginReg'));
    $('#register-form').prepend('<h2>Vytvoření nového účtu BERTISON</h2>');
}

